import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';

function ExitButton({ classes, onClick }) {
  return (
    <svg height="24" width="24" viewBox="0 0 24 24" onClick={onClick} className={classes.root}>
      <path d="M19,6.41L17.59,5,12,10.59,6.41,5,5,6.41,10.59,12,5,17.59,6.41,19,12,13.41,17.59,19,19,17.59,13.41,12z" />
    </svg>
  );
}

ExitButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
};

const stylesheet = theme => ({
  root: {
    width: 48,
    height: 48,
    position: 'absolute',
    top: 0,
    right: 0,
    padding: 1.5 * theme.spacing.unit,
    fill: theme.palette.common.lightBlack,
    transition: `opacity ${theme.transitions.duration.shortest}ms`,
    willChange: 'opacity',
    cursor: 'pointer',
    '&:hover': {
      opacity: 0.7,
    },
  },
});

export default injectSheet(stylesheet)(ExitButton);



// WEBPACK FOOTER //
// ./src/site-render/src/Dialog/ExitButton.js